module.exports = __webpack_public_path__ + "static/img/bg_test3.b4fbbfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_test3.jpg
// module id = V46K
// module chunks = 1